import { render } from "./Navbar.vue?vue&type=template&id=10f7edf4"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=10f7edf4&lang=css"
script.render = render

export default script